module.exports = __webpack_public_path__ + "c9f618180c105c7f35b0a653c4e07568.png";